import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LinePreview from './LinePreview';
import SizePreview from './SizePreview';

const ShowPreview = ({ showPreview, setShowPreview, formData = {}, title }) => {
  const [warning, setWarning] = useState(null);
  if (!showPreview) return null;
  // Normalize the "space" field to lowercase for comparison
  const spaceType = (formData.space || '').toString().trim().toLowerCase();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000]">
      <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col justify-center items-center max-w-lg w-full max-h-[80vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">
          {title || 'Preview'} {formData.crn ? `(${formData.crn
            ? String(formData.crn).slice(0, 4) + "-" +
            String(formData.crn).slice(4, 8) + "-" +
            String(formData.crn).slice(8, 12) + "-" +
            String(formData.crn).slice(12)
            : '-'})` : ""}
        </h2>

        {warning && (
          <div className="mb-4 p-3 bg-yellow-100 text-red-900 rounded-md text-xl">
            {warning}
          </div>
        )}

        {spaceType === 'line' ? (
          <LinePreview formData={formData} />
        ) : spaceType === 'box' ? (
          <SizePreview formData={formData} onOverflow={setWarning} />
        ) : (
          <div className="text-gray-900 italic">
            No preview available — please select "Line" or "Size".
          </div>
        )}

        <button
          type="button"
          onClick={() => setShowPreview(false)}
          className="mt-4 bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600 z-10"
        >
          Close
        </button>
      </div>
    </div>
  );
};

ShowPreview.propTypes = {
  showPreview: PropTypes.bool.isRequired,
  setShowPreview: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string,
};

ShowPreview.defaultProps = {
  title: 'Preview',
};

export default ShowPreview;
